import type { HostFeatures } from '@jet-app/music-classical/dependencies/features';
export type { HostFeatures as Features } from '@jet-app/music-classical/dependencies/features';

export function getFeatures(): HostFeatures {
    return {};
}
